// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input[data-v-4934447f] .v-input__slot{padding-left:0!important}.color-pointer[data-v-4934447f]{border:thin solid rgba(0,0,0,.2)}", ""]);
// Exports
module.exports = exports;
